import { IconClose } from "../Icons";
import { Subtitle } from "../Typography";
import "./Modal.scss";

interface Props {
  title?: string;
  open: boolean;
  onClose: any
  children: any;
}

export const Modal = ({ title, open, onClose, children }: Props) => {
  return open ? (
    <div className="modal">
      <div className="container">
        <div className="title-row">
          <Subtitle>{title}</Subtitle>
          <IconClose onClick={onClose} />
        </div>
        <div className="content">{children}</div>
      </div>
    </div>
  ) : <></>;
};
